import React from 'react';
import {designSystemToken, Label} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import Duration from '@/types/models/pricing/duration';
import TypeSelector from '@/components/type-selector';
import styles from './DurationToggle.module.scss';

const getDurationTypes = (disabledType?: string) => [
  {
    id: Duration.MONTHLY.valueOf(),
    icon: (
      <Label
        className={
          disabledType === Duration.MONTHLY.toString()
            ? styles.disabledType
            : ''
        }
        size="md"
      >
        {translate('Monthly')}
      </Label>
    ),
  },
  {
    id: Duration.YEARLY.valueOf(),
    icon: (
      <Label
        className={
          disabledType === Duration.YEARLY.toString() ? styles.disabledType : ''
        }
        size="md"
      >
        {translate('Yearly-20% off')}
      </Label>
    ),
  },
];

const getUnselectedDuration = (duration: Duration) =>
  duration === Duration.YEARLY ? Duration.MONTHLY : Duration.YEARLY;

type DurationToggleProps = {
  selectedDuration: Duration;
  handleDurationChange: (duration: string) => void;
  isDisabled: boolean;
};

function DurationToggle({
  selectedDuration,
  handleDurationChange,
  isDisabled,
}: DurationToggleProps) {
  return (
    <div className={styles.typeSelectorContainer}>
      <TypeSelector
        testID="plan-duration-selector"
        types={getDurationTypes(
          isDisabled
            ? getUnselectedDuration(selectedDuration).toString()
            : undefined
        )}
        selectedTypeId={selectedDuration.valueOf()}
        onChange={!isDisabled ? handleDurationChange : () => {}}
        containerStyle={styles.typeSelector}
        backgroundColor={designSystemToken('semantic.bg.tertiary')}
        selectionColor={designSystemToken('semantic.bg.primary')}
        borderColor={designSystemToken('semantic.bg.transparent')}
      />
    </div>
  );
}

export default DurationToggle;
